import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment';

export interface RequestEmailChangePayload {
  currentPassword: string;
  newEmailAddress: string;
}

@Injectable({
  providedIn: 'root',
})
export class EmailApiService {
  private readonly http = inject(HttpClient);

  public requestEmailChange(payload: RequestEmailChangePayload) {
    return this.http.put(`${environment.restEndpoint}/requestEmailAddressChange`, payload);
  }

  public activateNewEmail(token: string) {
    return this.http.put(`${environment.restEndpoint}/confirmEmailAddressChange`, { token });
  }
}
